import { faAtlas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export interface SampleQuestionProps {
  label: string;
  question: string;
  onClick: (question: string) => void;
}

export function SampleQuestion({ label, question, onClick }: SampleQuestionProps) {
  return (
    <button
      type="button"
      className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 dark:hover:border-gray-300 focus:outline-hidden focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 m-2"
      onClick={() => onClick(question)}>
      <FontAwesomeIcon icon={faAtlas} />
      <h3 className="font-semibold">{label}</h3>
      <span className="mt-2 block text-sm font-semibold text-gray-900">{question}</span>
    </button>
  );
}
